import React from 'react';

function Settings() {
    return (
        <div id="settings-content" className="p-8 bg-cream font-script">
            <div className="max-w-2xl mx-auto">
                <div id="security-settings" className="bg-white rounded-lg shadow p-8 card-hover">
                    <div className="flex items-center mb-8">
                        <i className="fa-solid fa-shield-alt text-3xl text-custom-green mr-4"></i>
                        <div>
                            <h2 className="text-2xl font-serif font-bold text-custom-green">Change Password</h2>
                            <p className="text-gray-600 mt-1">Update your admin account password</p>
                        </div>
                    </div>

                    <div className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">Current Password</label>
                            <input type="password"
                                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                                   placeholder="Enter current password"/>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">New Password</label>
                            <input type="password"
                                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                                   placeholder="Enter new password"/>
                            <p className="text-xs text-gray-500 mt-1">Password must be at least 8 characters long</p>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">Confirm New Password</label>
                            <input type="password"
                                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                                   placeholder="Confirm new password"/>
                        </div>



                        <div className="flex space-x-4 mt-8">
                            <button
                                className="flex-1 bg-custom-green text-white py-3 rounded-lg font-medium hover:bg-opacity-90 transition-colors">
                                Update Password
                            </button>
                            <button
                                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors">
                                Cancel
                            </button>
                        </div>
                    </div>

                    <div className="mt-8 pt-6 border-t">
                        <div className="flex items-start">
                            <i className="fa-solid fa-info-circle text-blue-500 mr-3 mt-1"></i>
                            <div>
                                <p className="text-sm font-medium text-gray-800 mb-1">Password Security Tips</p>
                                <ul className="text-sm text-gray-600 space-y-1">
                                    <li>• Use a combination of letters, numbers, and symbols</li>
                                    <li>• Avoid using personal information</li>
                                    <li>• Change your password regularly</li>
                                    <li>• Don't share your password with anyone</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Settings;